import { Injectable } from '@angular/core';

import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({ providedIn: 'root' })
export class P2ImportProcService {
    constructor(private dataTask: DataTaskService) {}

    /**
     * @datatask 877
     * @datataskName sp_ws_p2_p2importproc_list
     * @param params Import procedure list filters.
     * @returns Promise containing the available import procedures.
     */
    public getImportProceduresList(params: P2ImportProcListParams): Promise<P2ImportProcListItem[]> {
        return this.dataTask.Post(877, params);
    }
}

export interface P2ImportProcListParams {
    show_in_excelimport?: '0' | '1' | 'A';
}

export interface P2ImportProcListItem {
    item_id: string | number;
    item_name: string;
}
